import React, { useState, useEffect } from "react";
import axios from "axios";    
import "./ClientDocumentUpload.css";

const documentsList = [
  { key: "photo", label: "Photo*" },
  { key: "pan", label: "PAN Card*" },
  { key: "address", label: "Address Proof (Aadhar, Voter ID, Driving Licence)*" },
  { key: "cheque", label: "Cancelled Cheque*" },
  { key: "signedAof", label: "Signed AOF*" },
  { key: "signedSip", label: "Signed SIP Mandate*" },
];

const ClientDocumentUpload = ({ pan, onRiskProfile }) => {
  const [files, setFiles] = useState({});
  const [status, setStatus] = useState({});
  const [fileUrls, setFileUrls] = useState({});
  const [message, setMessage] = useState("");
   // ✅ ADD THIS HERE
  useEffect(() => {
    if (!pan) return;

    const fetchUploadedDocs = async () => {
      try {
        const res = await axios.post("/api/fetch-client", { pan });

        if (res.data.success && res.data.data) {
          const clientData = res.data.data;
          const docs = clientData.documents || {};

          // Set the uploaded file URLs
          setFileUrls(docs);

          // Update status for already uploaded files
          const newStatus = {};
          documentsList.forEach(doc => {
            newStatus[doc.key] = docs[doc.key] ? "Completed" : "Pending";
          });
          setStatus(newStatus);
        }
      } catch (err) {
        console.error("Failed to fetch uploaded docs:", err);
      }
    };

    fetchUploadedDocs();
  }, [pan]);

  const handleFileChange = (e, key) => {
    setFiles({ ...files, [key]: e.target.files[0] });
    setStatus({ ...status, [key]: "Pending" });
    setMessage("");
  };

  const handleUpload = async (key) => {
  if (!files[key]) {
    alert("Please select a file first");
    return;
  }

  try {
   const formData = new FormData();

formData.append("pan", pan);        // 👈 REQUIRED (comes from props)
formData.append("docType", key);    // 👈 photo / pan / address / cheque
formData.append("file", files[key]);



    const res = await axios.post(
      "/api/uploadDocument",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    if (!res.data.success) {
  alert("Upload failed");
  return;
    }

    setFileUrls(prev => ({
  ...prev,
  [key]: res.data.url // use the URL sent from backend
}));


   if (res.data.success) {
  setStatus(prev => ({
    ...prev,
    [key]: "Completed"
  }));

  setMessage("Upload completed successfully");
}
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed");
  }
};

const handleView = (key) => {
  if (!fileUrls[key]) {
    alert("File not found!");
    return;
  }
  window.open(fileUrls[key], "_blank");
};


  return (
    <div className="upload-page">
      <h2 className="page-title">Client Document Upload</h2>

      <div className="document-grid">
        {documentsList.map((doc) => (
          <div className="doc-card" key={doc.key}>
            <div className="doc-header">
              <span className="doc-title">{doc.label}</span>
              <span className={`status ${status[doc.key] || "pending"}`}>
                {status[doc.key] || "Pending"}
              </span>
            </div>

            <input
              type="file"
              onChange={(e) => handleFileChange(e, doc.key)}
            />

            <div className="doc-actions">
              <button
                className="btn-upload"
                onClick={() => handleUpload(doc.key)}
              >
                Upload
              </button>

              <button
                className="btn-view"
                onClick={() => handleView(doc.key)}
                disabled={!fileUrls[doc.key]}
              >
                View
              </button>
            </div>
          </div>
        ))}
      </div>

      {message && (
        <p
          style={{
            color: "green",
            fontWeight: "600",
            marginTop: "15px",
            textAlign: "center",
          }}
        >
          {message}
        </p>
      )}

      <div className="bottom-action">
        <button className="btn-red" onClick={onRiskProfile}>
  RISK PROFILE
</button>
      </div>
    </div>
  );
};

export default ClientDocumentUpload;
